import styleVariables from '!!dart-sass-variable-loader!../scss/variables/_colors.scss';

export default styleVariables;